import createSvgIcon from "./utils/createSvgIcon";

export default createSvgIcon(
  <>
    <path fillOpacity=".3" d="M2 22h20V2z"></path>
    <path d="M11 13.5L2 22h9z"></path>
  </>,
  "SignalCellular2Bar"
);
